import React from "react";
import styles from "../styles/Locators.module.css";
import logo from "../assets/logo.png";

const Locators = () => {
  return (
    <div className={styles.locatorsPage}>
      <h1 className={styles.pageTitle}> LOCATORS </h1>

      {/* ===================================================== */}
      {/* 1️⃣ getByRole */}
      {/* ===================================================== */}
      <div className={styles.card}>
        <h2>getByRole()</h2>

        <div className={styles.cardContent}>
          <div className={styles.leftSide}>
            <button className={`${styles.btn} ${styles.primary}`}>
              Role Button
            </button>
          </div>

          <div className={styles.codeBlock}>
            <pre>
{`// Locate button using role
await page.getByRole('button', { name: 'Role Button' }).click();`}
            </pre>
          </div>
        </div>
      </div>

      {/* ===================================================== */}
      {/* 2️⃣ getByText */}
      {/* ===================================================== */}
      <div className={styles.card}>
        <h2>getByText()</h2>

        <div className={styles.cardContent}>
          <div className={styles.leftSide}>
            <p>Bspark Software Technologies</p>
          </div>

          <div className={styles.codeBlock}>
            <pre>
{`// Locate using visible text
await page.getByText('Bspark Software Technologies');`}
            </pre>
          </div>
        </div>
      </div>

      {/* ===================================================== */}
      {/* 3️⃣ getByLabel & getByPlaceholder */}
      {/* ===================================================== */}
      <div className={styles.card}>
        <h2>getByLabel() & getByPlaceholder()</h2>

        <div className={styles.cardContent}>
          <div className={styles.leftSide}>
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              placeholder="Enter username"
              className={styles.input}
            />
          </div>

          <div className={styles.codeBlock}>
            <pre>
{`// Locate by label
await page.getByLabel('Username').fill('John');

// Locate by placeholder
await page.getByPlaceholder('Enter username').fill('John');`}
            </pre>
          </div>
        </div>
      </div>

      {/* ===================================================== */}
      {/* 4️⃣ getByAltText */}
      {/* ===================================================== */}
      <div className={styles.card}>
        <h2>getByAltText()</h2>

        <div className={styles.cardContent}>
          <div className={styles.leftSide}>
            <img
              src={logo}
              alt="company logo"
              className={styles.testImage}
            />
          </div>

          <div className={styles.codeBlock}>
            <pre>
{`// Locate image using alt text
await page.getByAltText('company logo');`}
            </pre>
          </div>
        </div>
      </div>

      {/* ===================================================== */}
      {/* 5️⃣ getByTitle */}
      {/* ===================================================== */}
      <div className={styles.card}>
        <h2>getByTitle()</h2>

        <div className={styles.cardContent}>
          <div className={styles.leftSide}>
            <button
              title="Title Based Button"
              className={`${styles.btn} ${styles.success}`}
            >
              Hover Me
            </button>
          </div>

          <div className={styles.codeBlock}>
            <pre>
{`// Locate using title attribute
await page.getByTitle('Title Based Button').click();`}
            </pre>
          </div>
        </div>
      </div>

      {/* ===================================================== */}
      {/* 6️⃣ getByTestId */}
      {/* ===================================================== */}
      <div className={styles.card}>
        <h2>getByTestId()</h2>

        <div className={styles.cardContent}>
          <div className={styles.leftSide}>
            <button
              data-testid="testid-button"
              className={`${styles.btn} ${styles.primary}`}
            >
              TestId Button
            </button>
          </div>

          <div className={styles.codeBlock}>
            <pre>
{`// Locate using test id
await page.getByTestId('testid-button').click();`}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Locators;